import api from './api';

export const getTaxSetting = () => {
  return api.get('/settings/tax');
};

export const updateTaxSetting = (taxRatePercent) => {
  return api.patch('/settings/tax', { taxRatePercent });
};
